module.exports = __webpack_public_path__ + "img/second_4.517312e2.png";